// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : Removed the unused 'line' and 'AutoLoan Index'
// MODFIED DATA : 01-08-2025
import PreCloseLoanActionTypes from './pre-close-loan.types';

/** ***************** FETCH PRE CLOSE LOAN MEMBER DETAILS START *********************** */
export const fetchPreCloseLoanListStart = (getData: any) => ({
	type: PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_START,
	payload: getData,
});

export const fetchPreCloseLoanListSuccess = (successData: any) => ({
	type: PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const fetchPreCloseLoanListFailure = (failureData: any) => ({
	type: PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const fetchPreCloseLoanListResponseReset = () => ({
	type: PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_RESPONSE_RESET,
});

export const fetchPreCloseLoanListResponseChanged = () => ({
	type: PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH PRE CLOSE LOAN MEMBER DETAILS END *********************** */

/** ***************** UPDATE  PRE CLOSE LOAN START *********************** */
export const updatePreCloseLoanDetailsStart = (getData: any) => ({
	type: PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_START,
	payload: getData,
});

export const updatePreCloseLoanDetailsSuccess = (successData: any) => ({
	type: PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const updatePreCloseLoanDetailsFailure = (failureData: any) => ({
	type: PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const updatePreCloseLoanDetailsReset = () => ({
	type: PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_RESET,
});

export const updatePreCloseLoanDetailsChanged = () => ({
	type: PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_CHANGED,
});
/** ***************** UPDATE  PRE CLOSE LOAN END *********************** */

/** ***************** GET Close Loan START *********************** */
export const getBranchEODStart = (getData: any) => ({
	type: PreCloseLoanActionTypes.GET_BRANCH_EOD_START,
	payload: getData,
});

export const getBranchEODSuccess = (successData: any) => ({
	type: PreCloseLoanActionTypes.GET_BRANCH_EOD_SUCCESS,
	payload: successData,
});

export const getBranchEODFailure = (failureData: any) => ({
	type: PreCloseLoanActionTypes.GET_BRANCH_EOD_FAILURE,
	payload: failureData,
});

export const getBranchEODReset = () => ({
	type: PreCloseLoanActionTypes.GET_BRANCH_EOD_RESET,
});

export const getBranchEODChanged = () => ({
	type: PreCloseLoanActionTypes.GET_BRANCH_EOD_CHANGED,
});
/** ***************** GET Close Loan END *********************** */

/** ***************** REVERT Close Loan START *********************** */
export const revertPreCloseLoanDetailsStart = (getData: any) => ({
	type: PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_START,
	payload: getData,
});

export const revertPreCloseLoanDetailsSuccess = (successData: any) => ({
	type: PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const revertPreCloseLoanDetailsFailure = (failureData: any) => ({
	type: PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const revertPreCloseLoanDetailsReset = () => ({
	type: PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_RESET,
});

export const revertPreCloseLoanDetailsChanged = () => ({
	type: PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_CHANGED,
});
/** ***************** REVERT Close Loan END *********************** */
